(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["htt-course-map"] && !Shopify.designMode) return;
  try {
    

(function () {
  function initAll() {
    document.querySelectorAll('[data-htt-course-map]:not([data-htt-ready])').forEach(initMap);
  }

  function loadGoogleMaps(key) {
    if (window.google && window.google.maps && window.google.maps.Map) return Promise.resolve(window.google.maps);
    if (window.httMapsGoogleLoading) return window.httMapsGoogleLoading;
    window.httMapsGoogleLoading = new Promise(function (resolve, reject) {
      const callback = 'httCourseGoogleMapReady';
      const script = document.createElement('script');
      window[callback] = function () {
        delete window[callback];
        resolve(window.google.maps);
      };
      script.async = true;
      script.src = 'https://maps.googleapis.com/maps/api/js?key=' + encodeURIComponent(key) + '&v=weekly&loading=async&callback=' + callback;
      script.onerror = function () {
        delete window[callback];
        reject(new Error('Google Maps could not load'));
      };
      document.head.appendChild(script);
    });
    return window.httMapsGoogleLoading;
  }
  function initGoogleMap(root, key) {
    const surface = root.querySelector('[data-google-canvas]');
    const search = root.querySelector('[data-map-search]');
    const items = Array.from(root.querySelectorAll('[data-map-course]'));
    const courses = items.map(function (item) {
      return {
        item: item,
        lat: Number(item.dataset.lat),
        lng: Number(item.dataset.lon),
        title: item.dataset.title,
        href: item.dataset.href,
        image: item.dataset.image || ''
      };
    });
    const spots = [];
    courses.forEach(function (course) {
      let spot = spots.find(function (point) {
        return Math.abs(point.lat - course.lat) < .000001 && Math.abs(point.lng - course.lng) < .000001;
      });
      if (!spot) {
        spot = {lat:course.lat,lng:course.lng,courses:[]};
        spots.push(spot);
      }
      spot.courses.push(course);
    });
    loadGoogleMaps(key).then(function (googleMaps) {
      root.classList.add('is-google-loading');
      const initialCenter = {lat:Number(root.dataset.lat),lng:Number(root.dataset.lon)};
      const initialZoom = Math.max(7,(Number(root.dataset.zoom) || 10) - (window.innerWidth < 600 ? 1 : 0));
      const map = new googleMaps.Map(surface, {
        center: initialCenter,
        zoom: initialZoom,
        mapTypeId: 'roadmap',
        streetViewControl: false,
        mapTypeControl: false,
        fullscreenControl: false,
        gestureHandling: 'cooperative',
        clickableIcons: false
      });
      const popup = new googleMaps.InfoWindow({maxWidth:285});
      function openSpot(spot) {
        popup.close();
        const content = document.createElement('div');
        content.className = 'htt-google-course-popup';
        const shown = spot.courses.filter(function (course) { return !course.item.hidden; });
        if (!shown.length) return;
        if (shown[0].image) {
          const photo = document.createElement('img');
          photo.src = shown[0].image;
          photo.alt = shown[0].title;
          content.appendChild(photo);
        }
        shown.forEach(function (course) {
          const heading = document.createElement('h3');
          heading.textContent = course.title;
          content.appendChild(heading);
          const link = document.createElement('a');
          link.href = course.href;
          link.textContent = root.dataset.bookLabel || 'View Tee Times';
          content.appendChild(link);
        });
        popup.setContent(content);
        popup.open({anchor:spot.marker,map:map});
      }
      spots.forEach(function (spot) {
        const icon = {
          path: googleMaps.SymbolPath.CIRCLE,
          scale:17,
          fillColor:'#277c52',
          fillOpacity:1,
          strokeColor:'#ffffff',
          strokeWeight:3,
          labelOrigin: new googleMaps.Point(0,0)
        };
        spot.marker = new googleMaps.Marker({
          map:map,
          position:{lat:spot.lat,lng:spot.lng},
          title:spot.courses.map(function (course) {return course.title;}).join(', '),
          icon:icon,
          label:{text:'⚑',color:'#ffffff',fontSize:'20px',fontWeight:'bold'}
        });
        spot.marker.addListener('click',function () {openSpot(spot);});
      });
      items.forEach(function (item) {
        const control = item.querySelector('[data-map-locate]');
        const course = courses.find(function (entry) {return entry.item === item;});
        control.addEventListener('click',function () {
          const spot = spots.find(function (point) {return point.courses.includes(course);});
          map.panTo({lat:course.lat,lng:course.lng});
          if (map.getZoom() < 12) map.setZoom(12);
          openSpot(spot);
        });
      });
      search.addEventListener('input',function () {
        const query = search.value.trim().toLowerCase();
        items.forEach(function (item) {item.hidden = !item.dataset.title.toLowerCase().includes(query);});
        root.querySelector('[data-map-empty]').style.display = items.every(function (item) {return item.hidden;}) ? 'block' : 'none';
        popup.close();
        spots.forEach(function (spot) {
          spot.marker.setMap(spot.courses.some(function (course) {return !course.item.hidden;}) ? map : null);
        });
      });
      root.classList.add('is-google-map');
      root.classList.remove('is-google-loading');
    }).catch(function () {
      root.classList.remove('is-google-loading');
      root.removeAttribute('data-google-key');
      root.removeAttribute('data-htt-ready');
      initMap(root);
    });
  }

  function initMap(root) {
    root.setAttribute('data-htt-ready', 'true');
    const googleKey = root.dataset.googleKey;
    if (googleKey) {
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(function (entries) {
          if (entries.some(function (entry) {return entry.isIntersecting;})) {
            observer.disconnect();
            initGoogleMap(root,googleKey);
          }
        },{rootMargin:'280px'});
        observer.observe(root);
      } else initGoogleMap(root,googleKey);
      return;
    }
    const canvas = root.querySelector('[data-map-canvas]');
    const tiles = root.querySelector('[data-map-tiles]');
    const pins = root.querySelector('[data-map-pins]');
    const search = root.querySelector('[data-map-search]');
    const items = Array.from(root.querySelectorAll('[data-map-course]'));
    const earth = 256;
    const minZoom = 8;
    const maxZoom = 15;
    let zoom = Number(root.dataset.zoom) || 10;
    if (window.innerWidth < 600) zoom = Math.max(minZoom, zoom - 1);
    let center = { lat: Number(root.dataset.lat), lon: Number(root.dataset.lon) };
    const original = { ...center, zoom };
    let activePoint = null;
    let dragging = null;
    let popup = null;
    const courseData = items.map((item) => ({
      item,
      lat: Number(item.dataset.lat),
      lon: Number(item.dataset.lon),
      title: item.dataset.title,
      href: item.dataset.href,
      image: item.dataset.image || ''
    }));
    const spots = [];
    courseData.forEach((course) => {
      let spot = spots.find((point) => Math.abs(point.lat - course.lat) < .000001 && Math.abs(point.lon - course.lon) < .000001);
      if (!spot) { spot = { lat: course.lat, lon: course.lon, courses: [] }; spots.push(spot); }
      spot.courses.push(course);
    });
    function project(lat, lon, z) {
      const latitude = Math.min(85.05113, Math.max(-85.05113, lat)) * Math.PI / 180;
      const scale = earth * Math.pow(2, z);
      return { x: (lon + 180) / 360 * scale, y: (1 - Math.log(Math.tan(latitude) + 1 / Math.cos(latitude)) / Math.PI) / 2 * scale };
    }
    function inverse(x, y, z) {
      const scale = earth * Math.pow(2, z);
      return { lon: x / scale * 360 - 180, lat: Math.atan(Math.sinh(Math.PI * (1 - 2 * y / scale))) * 180 / Math.PI };
    }
    function visible(point) {
      return point.courses.some((course) => !course.item.hidden);
    }
    function repaint() {
      const width = canvas.clientWidth;
      const height = canvas.clientHeight;
      if (!width || !height) return;
      const world = project(center.lat, center.lon, zoom);
      const left = world.x - width / 2;
      const top = world.y - height / 2;
      const limit = Math.pow(2, zoom);
      const minX = Math.floor(left / earth);
      const maxX = Math.floor((left + width) / earth);
      const minY = Math.max(0, Math.floor(top / earth));
      const maxY = Math.min(limit - 1, Math.floor((top + height) / earth));
      tiles.replaceChildren();
      for (let x = minX; x <= maxX; x++) {
        for (let y = minY; y <= maxY; y++) {
          const img = document.createElement('img');
          img.className = 'htt-course-map__tile';
          img.alt = '';
          img.loading = 'lazy';
          img.draggable = false;
          img.src = 'https://tile.openstreetmap.org/' + zoom + '/' + ((x % limit + limit) % limit) + '/' + y + '.png';
          img.style.left = (x * earth - left) + 'px';
          img.style.top = (y * earth - top) + 'px';
          tiles.appendChild(img);
        }
      }
      pins.replaceChildren();
      spots.forEach((spot) => {
        if (!visible(spot)) return;
        const coords = project(spot.lat, spot.lon, zoom);
        const x = coords.x - left;
        const y = coords.y - top;
        if (x < -35 || x > width + 35 || y < -35 || y > height + 35) return;
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'htt-course-map__pin';
        if (activePoint === spot) button.classList.add('is-active');
        button.textContent = '\u2691';
        button.setAttribute('aria-label', spot.courses.map((course) => course.title).join(', '));
        button.style.left = x + 'px';
        button.style.top = y + 'px';
        const count = spot.courses.filter((course) => !course.item.hidden).length;
        if (count > 1) {
          const number = document.createElement('span');
          number.className = 'htt-course-map__pin-count';
          number.textContent = count;
          button.appendChild(number);
        }
        button.addEventListener('click', (event) => { event.stopPropagation(); showPopup(spot); });
        pins.appendChild(button);
      });
      if (popup && activePoint) positionPopup(activePoint);
    }
    function closePopup() {
      if (popup) popup.remove();
      popup = null;
      activePoint = null;
      pins.querySelectorAll('.is-active').forEach((node) => node.classList.remove('is-active'));
    }
    function positionPopup(spot) {
      if (!popup) return;
      const width = canvas.clientWidth;
      const height = canvas.clientHeight;
      const centerPos = project(center.lat, center.lon, zoom);
      const pos = project(spot.lat, spot.lon, zoom);
      const x = pos.x - centerPos.x + width / 2;
      const y = pos.y - centerPos.y + height / 2;
      popup.style.left = Math.max(110, Math.min(width - 110, x)) + 'px';
      const popupHeight = popup.offsetHeight;
      if (y >= popupHeight + 50) {
        popup.style.top = (y - 43) + 'px';
        popup.style.transform = 'translate(-50%, -100%)';
      } else {
        popup.style.top = Math.max(10, Math.min(height - popupHeight - 10, y + 18)) + 'px';
        popup.style.transform = 'translateX(-50%)';
      }
    }
    function showPopup(spot) {
      closePopup();
      activePoint = spot;
      popup = document.createElement('div');
      popup.className = 'htt-course-map__popup';
      popup.setAttribute('role', 'dialog');
      popup.setAttribute('aria-label', 'Golf course details');
      const close = document.createElement('button');
      close.className = 'htt-course-map__popup-close';
      close.type = 'button';
      close.setAttribute('aria-label', 'Close course details');
      close.textContent = '\u00d7';
      close.addEventListener('click', (event) => { event.stopPropagation(); closePopup(); });
      popup.appendChild(close);
      const shown = spot.courses.filter((course) => !course.item.hidden);
      if (shown[0] && shown[0].image) {
        const img = document.createElement('img');
        img.src = shown[0].image;
        img.alt = shown[0].title;
        img.loading = 'lazy';
        popup.appendChild(img);
      }
      shown.forEach((course) => {
        const heading = document.createElement('h3');
        heading.textContent = course.title;
        popup.appendChild(heading);
        const link = document.createElement('a');
        link.href = course.href;
        link.textContent = root.dataset.bookLabel || 'View Tee Times';
        popup.appendChild(link);
      });
      canvas.appendChild(popup);
      repaint();
    }
    function setZoom(nextZoom, atX, atY) {
      nextZoom = Math.max(minZoom, Math.min(maxZoom, nextZoom));
      if (nextZoom === zoom) return;
      const width = canvas.clientWidth;
      const height = canvas.clientHeight;
      const point = project(center.lat, center.lon, zoom);
      const targetX = atX == null ? width / 2 : atX;
      const targetY = atY == null ? height / 2 : atY;
      const anchor = inverse(point.x + targetX - width / 2, point.y + targetY - height / 2, zoom);
      zoom = nextZoom;
      const anchorWorld = project(anchor.lat, anchor.lon, zoom);
      center = inverse(anchorWorld.x - targetX + width / 2, anchorWorld.y - targetY + height / 2, zoom);
      repaint();
    }
    root.querySelector('[data-map-plus]').addEventListener('click', () => setZoom(zoom + 1));
    root.querySelector('[data-map-minus]').addEventListener('click', () => setZoom(zoom - 1));
    root.querySelector('[data-map-reset]').addEventListener('click', () => {
      center = { lat: original.lat, lon: original.lon };
      zoom = original.zoom;
      closePopup();
      repaint();
    });
    canvas.addEventListener('wheel', (event) => {
      event.preventDefault();
      const rect = canvas.getBoundingClientRect();
      setZoom(zoom + (event.deltaY < 0 ? 1 : -1), event.clientX - rect.left, event.clientY - rect.top);
    }, { passive: false });
    canvas.addEventListener('pointerdown', (event) => {
      if (event.target.closest('button,a,.htt-course-map__popup')) return;
      dragging = { id: event.pointerId, x: event.clientX, y: event.clientY };
      canvas.setPointerCapture(event.pointerId);
    });
    canvas.addEventListener('pointermove', (event) => {
      if (!dragging || dragging.id !== event.pointerId) return;
      const dx = event.clientX - dragging.x;
      const dy = event.clientY - dragging.y;
      dragging.x = event.clientX;
      dragging.y = event.clientY;
      const current = project(center.lat, center.lon, zoom);
      center = inverse(current.x - dx, current.y - dy, zoom);
      closePopup();
      repaint();
    });
    function endDrag() { dragging = null; }
    canvas.addEventListener('pointerup', endDrag);
    canvas.addEventListener('pointercancel', endDrag);
    canvas.addEventListener('click', (event) => {
      if (event.target === canvas || event.target === tiles || event.target.classList.contains('htt-course-map__tile')) closePopup();
    });
    canvas.addEventListener('keydown', (event) => {
      const move = { ArrowLeft: [80, 0], ArrowRight: [-80, 0], ArrowUp: [0, 80], ArrowDown: [0, -80] }[event.key];
      if (move) {
        event.preventDefault();
        const current = project(center.lat, center.lon, zoom);
        center = inverse(current.x + move[0], current.y + move[1], zoom);
        repaint();
      }
      if (event.key === '+' || event.key === '=') setZoom(zoom + 1);
      if (event.key === '-') setZoom(zoom - 1);
      if (event.key === 'Escape') closePopup();
    });
    items.forEach((item) => {
      const button = item.querySelector('[data-map-locate]');
      button.addEventListener('click', () => {
        const course = courseData.find((entry) => entry.item === item);
        center = { lat: course.lat, lon: course.lon };
        zoom = Math.max(zoom, 12);
        const spot = spots.find((point) => point.courses.includes(course));
        showPopup(spot);
      });
    });
    search.addEventListener('input', () => {
      const query = search.value.trim().toLowerCase();
      items.forEach((item) => { item.hidden = !item.dataset.title.toLowerCase().includes(query); });
      root.querySelector('[data-map-empty]').style.display = items.every((item) => item.hidden) ? 'block' : 'none';
      closePopup();
      repaint();
    });
    if ('ResizeObserver' in window) new ResizeObserver(repaint).observe(canvas);
    repaint();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();


  } catch(e) { console.error(e); }
})();
})();
